import { QuickSelect } from '@/components/types'
import { getQuarter, subDays, subQuarters } from 'date-fns'
import { getTimeBefore } from '../getTimeBefore'

/**
 *
 * @param qs
 * @returns number
 * @description Convert a QuickSelect to the previous quarter of the year.
 * The previous quarter is defined as the quarter that ended before the current quarter.
 */
export const quickSelectToLastQuarter = (today: Date, qs: QuickSelect): number => {
  switch (qs.start) {
    case 'yesterday': {
      const yesterday = subDays(new Date(today.toISOString()), 1)
      const timeBefore = getTimeBefore(yesterday, qs.steps, qs.unit)
      return getQuarter(subQuarters(new Date(timeBefore.from), 1))
    }
    case 'now': {
      const timeBefore = getTimeBefore(today, qs.steps, qs.unit)
      return getQuarter(subQuarters(new Date(timeBefore.from), 1))
    }
  }
}
